/* NFA page transitions: yellow drop from the click point on menu links, then navigate.
   Also exposes window.NFA.drop() which the homepage entrance reuses. */
(function () {
  var root = document.documentElement;
  var cfg = window.NFA_SETTINGS || {};
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function duration(el) {
    var v = parseFloat(getComputedStyle(el || root).getPropertyValue('--nfa-duration'));
    return reduced ? 160 : (v || 700);
  }

  /* Run the drop inside `layer` (a fixed, full-viewport element holding .nfa-halo and .nfa-drop). */
  function drop(layer, x, y, done) {
    var d = layer.querySelector('.nfa-drop'), h = layer.querySelector('.nfa-halo'), size = 120;
    var w = innerWidth, hh = innerHeight;
    var far = Math.max(Math.hypot(x, y), Math.hypot(w - x, y), Math.hypot(x, hh - y), Math.hypot(w - x, hh - y));
    var scale = (far / (size * 0.40)) * 1.2;   /* blob's shortest radius ~40% of box, 1.2 margin for the uneven edge */
    [d, h].forEach(function (el) { el.style.left = (x - size / 2) + 'px'; el.style.top = (y - size / 2) + 'px'; });
    layer.style.setProperty('--nfa-scale', scale.toFixed(2));
    layer.hidden = false;
    void d.offsetWidth;                          /* flush so the transition starts from scale(0) */
    layer.classList.add('is-entering');
    var fired = false;
    function finish() { if (fired) return; fired = true; done(); }
    d.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, duration(layer) + 120);   /* fallback if transitionend never fires */
  }

  function leaveTo(href, yellow) {
    try {
      sessionStorage.setItem('nfa_arriving', '1');
      sessionStorage.setItem('nfa_yellow', yellow || getComputedStyle(root).getPropertyValue('--nfa-yellow').trim());
    } catch (e) {}
    location.assign(href);
  }

  window.NFA = { drop: drop, leaveTo: leaveTo, duration: duration };

  /* ---- menu link transitions ---- */
  if (!cfg.navTransitions) return;
  var selector = cfg.linkSelector || '.header__menu-item, .menu-drawer__menu-item, .header__heading-link';
  var layer = document.createElement('div');
  layer.className = 'nfa-wipe'; layer.hidden = true; layer.setAttribute('aria-hidden', 'true');
  layer.innerHTML = '<span class="nfa-halo"></span><span class="nfa-drop"></span>';
  document.body.appendChild(layer);
  var busy = false;

  document.addEventListener('click', function (e) {
    if (busy) { e.preventDefault(); return; }           /* ignore repeat taps mid-transition */
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !a.matches(selector)) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download')) return;
    var url; try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;                          /* external: normal behaviour */
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return; /* in-page anchor */
    e.preventDefault();
    busy = true;
    var x = e.clientX, y = e.clientY;
    if (e.detail === 0 || (x === 0 && y === 0)) { var r = a.getBoundingClientRect(); x = r.left + r.width / 2; y = r.top + r.height / 2; }
    /* Home: play the drop in white and let the entrance show again on arrival */
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var isHome = (url.pathname === rootPath || url.pathname === rootPath.replace(/\/$/, '') || url.pathname === '/');
    if (isHome) layer.style.setProperty('--nfa-yellow', '#ffffff'); else layer.style.removeProperty('--nfa-yellow');
    drop(layer, x, y, function () {
      if (isHome) { try { sessionStorage.removeItem('nfa_entered'); } catch (err) {} }
      leaveTo(url.href, isHome ? '#ffffff' : null);
    });
  }, true);

  addEventListener('pageshow', function (e) {          /* back button from bfcache: clear the yellow layer */
    if (!e.persisted) return;
    busy = false; layer.classList.remove('is-entering'); layer.hidden = true;
  });
})();
